import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import Camera from "./Camera";
import styles from "./WareHouse.module.css";
import { useStoreContext } from "../../../hooks/useStoreContext";
import axiosClient from "../../../services/axiosClient";
import { actions } from "../../../store";
import { MapContext } from "../../../contexts";
// import streamingClient from "../../../services/streamingClient";
import { changeDataCam } from "../../../utils";

const cx = classNames.bind(styles);
const WareHouse = ({ icon, name, show, parentShow, onClick, indexWareHouse, code, latitude, longitude, status, groupCode }) => {
  const { setListCameraCode, listCameraCode,zoom, setZoom } = React.useContext(MapContext)
  const [camera, setCamera] = useState([]);
  // eslint-disable-next-line 
  const [dataStore, dispatch] = useStoreContext()
  const [check, setCheck] = useState(false);
  const [size, setSize] = useState(1)
  const [pageEnd, setPageEnd] = useState(false);
  const checkStatus = (status) => {
    if (status !== 'all') {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    const getListCameraByCode = async () => {
      if (!pageEnd) {
        const res = await axiosClient.get(`cameraManagement/get-list-camera/?page=${size}&size=1000&warehouse_code=${code}&status_active=${ checkStatus(status) ? status : null}`, {
          params: {
            group_code: groupCode ? groupCode : null
          }
        })
        const camera = changeDataCam(res)
        if (res.data.length > 0) {
          setCamera(prev => [...prev, ...camera.data])
        } else {
          setPageEnd(true)
        }
      }
    }
    getListCameraByCode()
  }, [code, name, size, pageEnd, status, groupCode])

  const handleGetInfoWareHouse = () => {
    setZoom(12)
    dispatch(actions.getViewPort({
      LATITUDE: latitude,
      LONGITUDE: longitude,
    }))
  }

  const onClicks = (data) => {
    onClick(data);
  };

  const handleScrollBar = (e) => {
    // if (e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.target.clientHeight && !pageEnd) {
    //   setSize(size + 1)
    // }
  }
  return (
    <div className={cx("item")} onClick={handleGetInfoWareHouse}>
      <div onClick={(e) => onClicks(indexWareHouse)} className={cx("location")}>
        <span className={cx("icon")}>{icon}</span>
        <span className={cx("name")}>{name}</span>
      </div>
      {
        parentShow && show && (
          <div className={cx("warehouse")} onScroll={handleScrollBar}>
            {camera &&
              camera.map((item, index) => (
                <Camera
                  check={check}
                  key={index}
                  status={item.CAMERA?.STATUS_ACTIVE}
                  name={item.CAMERA?.NAME_CAM}
                  camID={item.CAMERA?.ID_CAM}
                  setCheck={setCheck}
                  prioritized={item.CAMERA.PRIORITIZED}
                  message={item.CAMERA.MESSAGE}
                  index={index}
                />
              ))}
          </div>
        )
      }
    </div >
  );
};
WareHouse.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  parentShow: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  // index: PropTypes.number.isRequired,
};
export default WareHouse;
